import Vue from 'vue'
import ordinations from '../../api/ordinations'

// initial state
const state = {
  ordinations: {root: [], totalCount: 0},
  saveOrdinationResponse: false,
  deleteOrdinationResponse: false
}

// getters
const getters = {
  ordinations: state => state.ordinations,
  saveOrdinationResponse: state => state.saveOrdinationResponse,
  deleteOrdinationResponse: state => state.deleteOrdinationResponse
}

// actions
const actions = {
  getOrdinations: function (context, data) {
    ordinations.getOrdinations(data, ordinations => {
      context.commit('RECEIVE_ORDINATION', { ordinations })
    })
  },
  saveOrdination: function (context, data) {
    ordinations.saveOrdination(data, saveOrdinationResponse => {
      context.commit('SAVE_RESPONSE', { saveOrdinationResponse })
    })
  },
  deleteOrdination: function (context, data) {
    ordinations.deleteOrdination(data, deleteOrdinationResponse => {
      context.commit('DELETE_RESPONSE', { deleteOrdinationResponse })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_ORDINATION'] (state, { ordinations }) {
    ordinations.totalCount = parseInt(ordinations.totalCount)
    state.ordinations = ordinations
  },
  ['SAVE_RESPONSE'] (state, { saveOrdinationResponse }) {
    state.saveOrdinationResponse = saveOrdinationResponse
  },
  ['DELETE_RESPONSE'] (state, { deleteOrdinationResponse }) {
    if(deleteOrdinationResponse.error == true) Vue.$notify.error(deleteOrdinationResponse.notice);
    else Vue.$notify.success(deleteOrdinationResponse.notice);
    state.deleteOrdinationResponse = deleteOrdinationResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ordinations.js